import type {
  CreatePublicApiTokenInput,
  CreatePublicApiTokenResponse,
  ListPublicApiTokensResponse,
  RevokePublicApiTokenInput,
  RevokePublicApiTokenResponse,
} from "schemas/generated/publicApiToken";
import type { RequestFn } from "./request";

export function createPublicApiTokensClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    list: (input: {
      workspaceId: string;
    }): Promise<ListPublicApiTokensResponse> => {
      return request<ListPublicApiTokensResponse>({
        method: "GET",
        path: "/api/v1/public-api-tokens",
        query: {
          workspaceId: input.workspaceId,
        },
      });
    },
    create: (
      input: CreatePublicApiTokenInput,
    ): Promise<CreatePublicApiTokenResponse> => {
      return request<CreatePublicApiTokenResponse>({
        method: "POST",
        path: "/api/v1/public-api-tokens",
        body: input,
      });
    },
    revoke: (
      input: RevokePublicApiTokenInput,
    ): Promise<RevokePublicApiTokenResponse> => {
      return request<RevokePublicApiTokenResponse>({
        method: "DELETE",
        path: `/api/v1/public-api-tokens/${encodeURIComponent(input.tokenId)}`,
      });
    },
  };
}
